// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"0481668e","348":"672eb6da","470":"ef73e879","516":"ce65f5da","639":"ef1f5282","735":"f70d073a","761":"1cdae479","815":"6e6b9202","971":"c0d0a994"}[chunkId] + ".css";
};